export const RESOURCE_ENDPOINT = '/csrf'
